/**
 * Blog card component for article previews
 * Displays blog post thumbnail, title, date, and excerpt with lazy loading
 */

import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import { getLowQualityPlaceholder, generateSrcSet } from 'libs/athos/components/ResultImage'

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function BlogCard({ blog }) {
  const articleImage = blog.image_alt || blog.image

  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [articleImage?.src])

  return (
    <a href={blog.url} className="group/blog-card flex flex-col md-max:gap-0.5" aria-label={`Read more about ${blog.title}`}>
      <div className="w-full aspect-1/1 bg-page-secondary overflow-hidden children:size-full children:object-cover children:group-hover/blog-card:scale-[1.025] children:transition-all">
        {articleImage?.src && (
          <img
            className="lazy size-full object-cover group-hover/blog-card:scale-[1.025] transition-all"
            src={getLowQualityPlaceholder(articleImage.src)}
            data-src={articleImage.src}
            data-srcset={generateSrcSet(articleImage.src, IMAGE_WIDTHS)}
            data-sizes="50vw"
            alt={articleImage.alt || blog.title}
            width={articleImage.width}
            height={articleImage.height}
          />
        )}
      </div>

      <div className="flex flex-col gap-y-0.5 md:p-1">
        <h3 className="paragraph-m font-extended font-semibold">{blog.title}</h3>
        {blog.excerpt && (
          <div className="w-fit richtext paragraph-s text-type-black-secondary">
            {blog.excerpt}
          </div>
        )}
        <div className="btn btn-text btn-primary btn-s w-fit group-hover/blog-card:opacity-50">
          <span className="text-line text-line-large">
            Read Article
          </span>
        </div>
      </div>
    </a>
  )
}
